export default {
  'subscribe': 'Subscribe',
  'subscription-header': 'Booksy Subscription',
  'your-subscription-header': 'Your Subscription',
  'subscription-info': 'Streamlining your day-to-day so you can focus on what you love and engage your community.',
  'contact-customer-support': 'Contact Customer Support',
  'pay-now': 'Pay now',
  'renew-subscription': 'Renew your subscription',
  'call-customer-support': 'Call {phoneNumber}',
  'help-hint': 'Need help?',
  'help-link': 'Contact us',
  'chat': 'Chat with us',
  'your-subscription-has-been-activated': 'Your subscription has been activated',
  'your-subscription-has-been-renewed': 'Your subscription has been successfully renewed',
  'subscription-price': 'Price: {price} / mo',
  'ltm-subscription-price': 'Price: {price} / {period} mo',
  'need-help-question': 'Need help?',
  'remind-me-later': 'Remind me later',
  'details-hide': 'Hide details',
  'details-show': 'Show details',
  'contact-us': 'Contact us',
  'error-support': 'Something went wrong, but we can help. Please verify your credit card information was entered correctly and that funds are available in your account. Contact your bank to ensure your card is active and this transaction can be approved.<br/>If these steps don\'t resolve the issue, please copy down or take a screenshot of this error ID code {code} and contact the Support Team via chat.',
  'cancellation-started': 'We’ve started the cancellation process',

  'boost': {
    'header': 'Boost',
    'info': 'Get a well-deserved Boost to attract new customers.',
    'feature': {
      'search': 'Better search results',
      'gallery': 'Gallery Spotlights',
      'marketing': 'Marketing exposure',
      'revenue': 'Increased revenue potential',
      'pay-once': 'Only pay once per customer',
    },
    'commision-info': 'Commission: Pay {commission}% only of the first visit for new clients found through Boost. No monthly fee.',
    'commision-info-tax': 'Commission: Pay {commission}% + tax only of the first visit for new clients found through Boost. No monthly fee.',
  },

  'braintree-form': {
    'title': 'Payment Method',
    'details': 'Payment Details',
    'name': 'Cardholder name',
    'card-number-input': 'Card number',
    'month': 'MM',
    'year': 'YY',
    'login-paypal': 'Login to PayPal account',
    'login-venmo': 'Login to Venmo account',
    'cvc-info': 'CVC is the three/four-digit number usually printed on the signature panel on the back of the card. This is an anti-fraud security feature to help verify that you are in possession of your credit card.',
    'paypal-failed': 'PayPal popup window failed to open. Please check your browser settings like the "blocked icon" at the browser address bar (top right corner).',
    'paypal-closed': 'Your Paypal popup window is closed. Please try again.',
    'fields-empty': 'Payment input fields are empty. Please try again.',
    'venmo-app-canceled': 'You canceled Venmo payment flow',
    'venmo-canceled': 'Venmo is not available or you aborted payment flow',
    'client-request-error': 'There was a problem with your request.',
    'card': 'Credit Card/Debit Card',
    'hint-paypal': 'Next step will take you to your PayPal account',
    'hint-venmo': 'Next step will take you to your Venmo account',
    'scan': 'Scan your card',
    'cardholder-name': 'Cardholder name',
    'card-number': 'Card number',
    'expiration-month': 'Month',
    'expiration-year': 'Year',
  },

  'start': {
    'header-text': 'Want more time to do what you love? Activate your Booksy subscription',
    'text-1': 'Your business, your way. Adjust your subscription at any time:',
    'subscription-feature': {
      'calendar': 'Calendar & Appointments',
      'shifts': 'Staff & Shift Management',
      'inventory': 'Inventory',
      'integrations': 'Integrations (i.e. Google, Instagram)',
      'stats': 'Stats & Reports',
      'tools': 'Marketing & Promotional Tools',
      'no-show': 'No-Show Protection',
      'gifts': 'Gift Cards, Packages, & Memberships',
    },
    'price-info': {
      'one-staffer': 'Price for account owner + {staffersIncluded} staff member: {totalPrice} / mo',
      'many-staffers': 'Price for account owner + {staffersIncluded} staff members: {totalPrice} / mo',
      'no-staffers': 'Price for account owner: {totalPrice} / mo',
      'price-net': '({price} NET)',
      'price-gross': '({price} GROSS)',
    },
    'price-info-hint': 'Adding each additional staff member will increase the price by {staffFullPrice}/ mo',
    'total': 'Total',
    'starting-at': 'Starting at:',
    'discounted-price-label': 'Your discounted price',
    'total-price': '{price} / mo',
    'total-price-ltm': '{price} / {period} mo',
    'total-price-net': '{price} NET (tax {tax}%)',
    'total-price-gross': '{price} GROSS (tax {tax}%)',
    'boost-commission-addon': 'Boost commission',
    'contact-us-to-subscribe': 'Contact us to subscribe',
    'offline-info': {
      'header': 'How much does it cost?',
      'description': 'Price of a Booksy Subscription starts from {price} / mo. Adding each additional staff member will increase the price. Contact us for more information.',
    },
    'submitted': {
      'title': 'Request has been submitted',
      'description': 'A member of our Customer Success team will be in touch shortly to finalize your transaction.',
    },
    'terms': 'Booksy Subscription <strong>Terms & Conditions</strong>',
    'ltm-info': {
      'title': 'Enjoy Booksy long-term and&nbsp;save!',
      'info': 'See how Booksy can help you manage your business in the long run. Subscribe for <strong>3, 6 or 12</strong> months and <strong>benefit from a discounted rate.</strong>',
      'period': '{count} months',
      'show-details': 'Show more details',
    },
  },

  'subscription-details': {
    'add-to-subscription': 'Add to your subscription:',
    'manage-your-account': 'Manage your account:',
    'switch-to-solo': 'Switch to Booksy Solo',
    'header': 'Want more time to do what you love?',
    'inactive-header': 'Want more time to do what you love? Reactive your Booksy subscription.',
    'inactive-info': '<p>Reactivate your subscription so that you can rely on Booksy for booking clients, marketing your business, managing the day-to-day, and building your community.</p><p>We\'re more than appointments, We’re your partner, your sidekick, your employee of the month.</p>',
    'fees': {
      'title': 'Fees',
      'price-per-month': 'Price per month',
      'price-per-month-plural': 'Price per month ({count} staff member) | Price per month ({count} staff members) | Price per month ({count} staff members)',
      'ltm-price': 'Price for {count} month | Price for {count} months | Price for {count} months',
      'next-payment': 'Next payment for subscription',
      'additional-staffer': 'Each additional staff member',
      'text-messages': 'Text Messages',
      'text-messages-description': 'Your Booksy subscription includes free Notification & Reminder texts. It might also include a limited amount of free Marketing texts. When you\'ve used up your free Marketing texts for the current monthly billing cycle you\'ll be charged per message. To see a summary of your current usage visit Billing Details.',
      'notifications-count': 'Number of free notification & reminder SMS',
      'notifications-count-unlimited': 'Unlimited free',
      'free-sms-count': 'Number of free marketing SMS',
      'paid-sms-count': 'Number of paid marketing SMS',
      'sms-cost': 'Cost of each Marketing text message above free limit',
      'sms-alert-cost': 'Marketing SMS cost alert per month',
      'sms-modify': 'Modify',
      'text-messages-settings': {
        'title': 'Text Message Settings',
        'sms-notifications': {
          'title': 'SMS notifications',
          'description': 'Enable SMS Notifications so Booksy can send your clients automated text messages with appointment confirmations and reminders on your behalf.',
        },
        'eco-mode': {
          'title': 'ECO mode',
          'description': 'Enable ECO Mode so Booksy can send your clients FREE push notifications instead of text messages for automated appointment confirmations and reminders. Clients must be logged in to their Booksy app in order to receive push notifications instead of text messages.',
        },
      },
      'paid-text-messages-settings': {
        'title': 'Paid text messages plan',
        'description': 'Text messages will be charged for according to the quantity of messages sent above the limit.',
        'current-plan': 'Current plan',
        'paid-messages': '{quantity} paid text messages',
        'paid-messages-cost': '({cost} /month limit)',
        'free-messages': 'Plan includes {quantity} free text messages',
      },
    },
    'revoke-suspension': 'Revoke suspension',
    'reactivate-your-account': 'Reactivate your account',
    'pay-now': 'Pay now',

    'boost-status-actions': {
      'turn-off': 'Deactivate',
      'request-turn-off': 'Request Deactivation',
      'turn-on': 'Activate',
    },

    'subscription-status': {
      'A': {
        'label': 'Active',
        'action': 'Suspend',
      },
      'S': {
        'label': 'Suspended',
      },
      'U': {
        'label': 'Suspension scheduled',
      },
      'B': {
        'label': 'Blocked',
      },
      'churned-active': {
        'label': 'Active till {date}',
      },
    },
  },

  'next-payment': {
    'view-title': 'Your Billing',
    'subscription-plan': 'Subscription Plan',
    'billing-cycle': ' Billing cycle: {cycleStart} - {cycleEnd}',
    'period': 'Booksy Subscription • {period} month | Booksy Subscription • {period} months | Booksy Subscription • {period} months',
    'renewal-date': 'Next payment • {date}',
    'discount': '{discount} discount for subscription',
    'discount-ltm': '{discount} discount for long-term subscription',
    'staffers-included': '{staffersCount} staff member included | {staffersCount} staff members included | {staffersCount} staff members included',
    'sms-limit': 'Free limit of {smsLimit} text messages',
    'additional-charges': 'Additional Monthly Charges',
    'additional-daily-charges': 'Additional Daily Charges',
    'charges-info': {
      'title': 'What are Additional Charges?',
      'text': `These are Booksy services that you've added to your subscription plan, such as additional Staff Member accounts or Text Messages over the free limit included in your subscription.<br/><br/>
      You will be charged for them on top of your subscription fee.
      <br/><br/>
      Services that are not included in your subscription plan are billed monthly, even if you have a long - term subscription.`,
    },
    'additional-billing-cycle': ' Billing cycle: {cycleStart} - {cycleEnd}',
    'additional-staffers': 'Additional Staff Members',
    'additional-staffers-count': '{count} staff member | {count} staff members | {count} staff members',
    'next-payment-date': 'Next payment • {date}',
    'additional-sms-usage': 'Additional SMS Usage',
    'additional-sms-paid': '{count} text above free limit (until now) | {count} texts above free limit (until now) | {count} texts above free limit (until now)',
    'additional-sms-date': 'Next payment • {date}',
    'gross-price': '{priceGross} gross',
    'vat-info': '{taxPercent} VAT',
    'tab-next-payment': 'Next payment',
    'tab-payment-history': 'Payment history',
    'status': {
      upcoming: 'Upcoming',
    },
    'boost-fees': 'Boost Fees',
    'boost-fees-price': '{price} (until now)',
    'boost-fees-clients-count': '{count} Boost Client today | {count} Boost Clients today | {count} Boost Clients today',
  },

  'set-as-default-modal': {
    'title': 'Set new card as default',
    'text': 'Are you sure you want to set this card as a default one ? This card will be charged for next billing payments.',
    'yes': 'Yes, change',
    'no': 'No, dismiss',
  },
  'overdue-payments': {
    'title': 'Overdue payments',
    'total-overdue': 'Total overdue: ',
    'retry-payment': 'Retry payment',
    'retry-payment-messages': {
      'processing': 'We are processing your payment...',
      'subscription-success-only': 'Subscription payment successful!',
      'boost-success-only': 'Boost payment successful!',
      'all-success': 'Payment successful!',
      'none-success': 'Payment failed. Try again using different card',
    },
  },
  'payment-details': {
    'title': 'Payment Details',
    'subscribe': 'Subscribe',
    'payment-method': 'Payment Method',
    'card-details': {
      'title': 'Card Details',
      'cardholder-name': 'Cardholder name',
      'address-line-1': 'Address Line 1',
      'city': 'City',
      'zipcode': 'Zip Code',
      'state': 'State',
      'multi-card': {
        'label': 'The selected card will be automatically set as a default one for billing payments.',
        'expired': 'Your card has expired',
        'add-new-card': 'Add New Card',
      },
    },
    'total-overdue': {
      'total-overdue': 'Total overdue:',
      'pay-now': 'Pay now',
      'subscription': 'Subscription:',
      'boost': 'Boost:',
    },
    'invoice-details': {
      'fill-address': 'Fill with Card Address',
      'header-warning': 'The provided information will be visible on your invoice so please make sure it’s correct.',
    },
    'save-changes': 'Save changes',
    'retry-payment': 'Retry payment',
    'update': 'Update payment method',
    'info': 'This is your default payment method for Booksy subscription and additional charges: ',
    'no-payment-method': 'There is no payment method added yet.',
    'overdue-message-1': 'Overdue amount: {overdueBalance}<br/>Your account has been disabled',
    'overdue-message-2': 'Overdue amount: {overdueBalance}<br/>Due date: {dueDate}',
    'overdue-message-3': 'Your account will be disabled tomorrow',
    'card': 'Credit card',
    'paypal': 'Paypal',
    'venmo': 'Venmo',
    'credit-card-with-masked-number': 'Credit Card {number}',
    'expires': 'Expires {expirationDate}',
    '3ds-failed': '3D Secure Failed',
  },

  'payment-method': {
    'add': 'Add payment method',
    'update': 'Update payment method',
    'set-as-default': 'Set as default',
    'expires': 'Expires {date}',
    'default': 'Default',
    'delete-card': 'Remove card',
    'select-card-brand': 'Select card brand',

    'delete-dialog': {
      'title': 'Delete Card?',
      'text': 'Are you sure you want to remove this card ? <br />Next available card will be selected as default one',
      'confirm': 'Yes, delete card',
      'cancel': 'Go back',
    },
  },

  'invoice': {
    'title': 'Invoice',
    'header': 'Invoice',
    'subscribe': 'Subscribe',
    'types': {
      'vat': 'I want to receive a VAT invoice',
      'sales': 'I want to receive a sales invoice',
      'regular': 'I want to receive a regular invoice',
    },
    'details-header': 'Invoice Details',
    'fields': {
      'tax-id-us': 'Tax ID (Employer Identification Number)',
      'tax-id-eu': 'VAT EU',
      'vat-number': 'VAT Number',
      'company-name': 'Company Name',
      'name': 'First Name',
      'surname': 'Last Name',
      'first-surname': 'First Name, Last Name',
      'house-number': 'House number',
      'street': 'Street',
      'address-line-1': 'Address Line 1',
      'address': 'Address',
      'city': 'City',
      'zipcode': 'Zip Code',
      'tax-group': 'Registered Tax Territory',
      'state': 'State',
      'email': 'Email Address',
    },
    'contact-to-update-details': 'Contact us to update details',
    'update-details': 'Update details',
    'additional-confirmation-info': 'Please make sure to update and confirm your invoicing details (mandatory)',
    'confirm-details': 'Confirm details',
    'registered-for-vat': 'I\'m registered for VAT',
  },

  'marketing-sms': {
    'title': 'Text message usage',
    'info': 'You will be charged for text messages based on your usage above free text messages limit.',
    'cost-summary': 'SMS cost summary',
    'cost-above-limit': 'Cost of each Marketing SMS above free limit',
    'cost-additional': 'Additional Marketing SMS cost this billing cycle',
    'cycle-date': 'For {nextCycleStart} to {nextCycleEnd}',
    'messages-sent': '{messagesCount} messages sent',
    'no-messages-sent': 'No messages sent',
    'above-free-limit': '{sentAbove} above free limit',
    'free-limit': 'Free limit: {limit} ',
    'unlimited': 'Unlimited free',
    'foo': 'bar',
  },

  'payment-method-subsection': {
    'current': 'Current Payment Method',
    'update': 'Update payment method',
    'change': 'Change',
    'methods': {
      'credit-card': 'Credit card {number}',
      'paypal': 'Paypal',
      'venmo': 'Venmo',
      'unknown': 'Unknown',
    },
  },

  'payment-messages': {
    'boost-blocked': {
      'title': 'Boost is blocked',
      'text': 'Due to unpaid Boost fees, Boost has been turned off for your account. To continue using Boost, make sure your payment method is up to date and your overdue balance is settled.',
    },
    'pay-overdue-fees': {
      'title': 'Pay overdue fees',
      'text': 'You have overdue subscription and Boost payments. Settle your outstanding balance to continue using Booksy without interruptions.',
      'overdue-subscription': ' Overdue subscription payment:',
      'overdue-boost': 'Overdue Boost payment:',
    },
    'pay-overdue-boost-fees': {
      'title': 'Pay overdue Boost fees',
      'text': "To continue using Boost to attract new clients and earn more revenue,  you'll need to settle your overdue balance.",
    },
    'trial': {
      'title': 'Unable to Manage Subscription',
      'text': 'Currently, you\'re not able to manage your subscription from here. Please contact Support so we can help you.',
    },
    'trial-expired': {
      'title': 'Your free trial will expire in {count} day | Your free trial will expire in {count} days | Your free trial will expire in {count} days',
      'title-shorter': 'Trial ends in {count} day | Trial ends in {count} days | Trial ends in {count} days',
      'title-last-day': 'Trial ends in {count} hour | Trial ends in {count} hours | Trial ends in {count} hours',
      'title-last-hour': 'Trial ends in less than 1 hour',
      'text-booksy-billing': 'You’re currently using Booksy in trial mode. Subscribe to Booksy and let us help you grow your business and connect with your clients.',
      'text-itunes-gpay': 'You’re currently using Booksy in trial mode. To continue growing your business and connecting with clients, go to your <strong>mobile app</strong> to select a subscription plan that suits you.<br><br>If you would like assistance or have any questions we are here to help.',
      'text-offline': 'You’re currently using Booksy in trial mode. Subscribe to Booksy and let us help you grow your business and connect with your clients. Contact us to select a subscription plan.',
      'text-staffer': 'We hope you enjoyed using Booksy during your free trial period. Get in touch with the account owner and let them know they can select a subscription plan.',
    },
    'trial-blocked': {
      'title': 'Trial Expired',
      'text-2': 'You are no longer on a free trial. Help your business grow with 24/7 availability and calendar management through Booksy.',
      'text': 'Your free trial has expired but don\'t worry. From your mobile Booksy App you can manage your subscription.',
      'text-booksy-billing': 'We hope you enjoyed using Booksy during your free trial period. Now let us help you manage your business and build your community.<br/><br/> Select a subscription plan that fits your business needs.',
      'text-itunes-gpay': 'We hope you enjoyed using Booksy during your free trial period. Now let us help you manage your business and build your community.<br/><br/>Go to your mobile app to select a subscription plan that fits your business needs.You are no longer on a free trial. Help your business grow with 24/7 availability and calendar management through Booksy.',
      'text-offline': 'We hope you enjoyed using Booksy during your free trial period. Now let us help you manage your business and build your community. Contact us to select a subscription plan that fits your business needs.',
      'text-staffer': 'We hope you enjoyed using Booksy during your free trial period. Get in touch with the account owner and let them know they can select a subscription plan.',
      'trial-extension': {
        'title': 'Want to extend your trial?',
        'descripction': 'Enjoy another 14 days with us for free to continue to explore what Booksy has to offer.',
        'extend-trial-button': 'Extend free trial',
        'success-toast': 'Trial extended by 14 days',
      },
    },
    'overdue-active': {
      'title': 'Payment Failed',
      'text': 'For some reason your payment didn\'t go through. Please contact us to figure out why and try again.',
    },
    'warning': {
      'title': 'Your account will be disabled tomorrow',
      'text': 'Please resolve your overdue balance so that you can continue to access your Booksy account and enjoy self-service customer bookings. If no action is taken your account will be disabled, and you won’t be able to confirm customer bookings.',
    },
    'overdue-blocked': {
      'title': 'Account Disabled',
      'text': 'Your account has been disabled. If you want to continue using Booksy, enable card payment and get back to business.',
    },
    'blocked': {
      'title': 'Your account has been disabled',
      'no-subscription': 'Your account access has been blocked due to an overdue balance.',
      'text': `Your account access has been blocked due to an overdue balance of {overdueBalance}. Customers will be able to view your profile and book appointments until {overdueDate}, but you won't be able to confirm those appointments until your account has been reactivated.<br/><br/>
      Don't miss out on all of that revenue, submit payment to get back to business.`,
    },
    'failed': {
      'title': 'Payment Failed',
      'text': `Oops, it looks like your payment didn't go through. Please confirm that your payment method is correct and try to run the payment again.`,
    },
    'churned': {
      'title': 'Your account has been disabled',
      'text': `Your account has been disabled. Please renew your subscription so that you can continue using Booksy to manage your business.<br/><br/>
      Don't miss out on all of that revenue, renew subscription to get back to business.`,
    },
    'token-error': {
      'title': 'Authorization error',
      'text': '',
    },
    'call-us': 'Call Us',
  },

  'unavailable': {
    'title': 'Unavailable',
    'text': 'Currently, you’re not able to manage your subscription from here. Try again from your mobile Booksy Biz app, or contact us for help.',
    'trial': {
      'title': 'Unable to Manage Subscription',
      'text': 'Currently, you’re not able to manage your subscription from this version of Booksy Biz. Try again from your mobile Booksy Biz app, or contact us for help.',
      'text-itunes': 'In order to manage your subscription please go to BooksyBiz app on iOS device.',
      'text-play': 'In order to manage your subscription please go to BooksyBiz app on Android device',
    },
  },

  'sms-alert': {
    'title': 'Marketing SMS cost alert',
    'info': 'Use this warning to help you keep track of your SMS fees once your free messages run out. Note: This alert will not prevent future text messages from being sent. You could incur costs beyond this threshold.',
    'warning': 'Warn me when my SMS fees exceed:',
  },

  'billing-details': {
    'header': 'Booksy Subscription',
    'subsections': {
      'discount': 'Discount',
      'boost': 'Boost (updated & charged daily)',
      'sms': 'Marketing text messages (updated daily)',
      'other': 'Other',
      'credits': 'Credits',
    },
    'subsection-headers': {
      'discount': 'Discount',
      'boost': 'Billing Details ⋅ Boost',
      'sms': 'Marketing Text Messages',
      'other': 'Billing Details ⋅ Other',
      'credits': 'Billing Details ⋅ Credits',
    },
    'billing-period': 'For {startDate} to {endDate}',
    'sub-total': 'Sub-total',
    'due': 'Due',
    'charged-boost': 'Charged (for Boost)',
    'empty': 'New billing cycle details will be available here soon.',
    'due-net': '{price} NET ({tax}% VAT)',
    'due-gross': '{price} GROSS ({tax}% VAT)',
    'billing-history': {
      'online': 'Credit Card',
      'offline': 'Offline',
      'download-error': 'Couldn\'t download the invoice!',
      'downloading': 'Downloading',
      'empty-list': 'No billing cycle completed yet',
      'issued': 'Issued {date}',
      'details': {
        'title': 'Billing Details',
        'number': 'No. {number}',
        'date-of-issue': 'Date of issue',
        'date-of-sale': 'Date of sale',
        'seller': 'Seller',
        'buyer': 'Buyer',
        'tax-id': 'Tax ID: {taxId}',
        'item-qty': 'Item / Qty',
        'tax-rate': 'Tax Rate',
        'tax-amount': 'Tax Amount',
        'net-value': 'Net Value',
        'gross-value': 'Gross Value',
        'amount': 'Amount',
        'discount': 'Discount',
        'text-messages-usage': 'Text messages usage',
        'paid-messages-sent': '{quantity} paid messages sent',
        'additional-costs': 'Additional costs',
        'total-gross': 'Total Gross',
        'invoice-number': 'Receipt No. {number}',
        'subtotal': 'Subtotal',
        'total': 'Total',
        'payment-method': 'Payment method:',
        'send-invoice-via-email': 'Send invoice via email',
        'sms': 'SMS',
        'staff-members': 'Staff Members',
        'booksy-subscription': 'Booksy Subscription',
        'special-offer': 'Special Offer',
      },
    },
  },

  'your-billing': {
    'overdue-payments': {
      'empty': {
        'title': 'All good!',
        'text': 'You don\'t have any overdue payments.',
      },

      'overdue-subscription': {
        'subscription': 'Booksy Subscription',
        'additional-staff-members': 'Additional Staff Members',
        'additional-text-message': 'Additional Text Message',
        'period': '{count} month | {count} months | {count} months',
        'additional': '{count} additional | {count} additional | {count} additional',
        'above-limit': '{count} above the limit | {count} above the limit | {count} above the limit',
      },

      'subscription': 'Subscription',
      'boost': 'Boost',
    },
  },

  'tablet': {
    'mo': 'mo',

    'log-out': 'Log out',
    'choose-your-plan': 'Choose Your Plan',

    'renew': 'Renew your subscription',
    'select-plan': 'Select your plan',
    'contact-us': 'Contact us',
    'call': 'Call',

    'restore': 'Restore',
    'need-help': 'Need help?',

    'activated': 'Your subscription has been activated!',
    'failed': 'Something went wrong during your subscription activation. Try again later or contact our customer success team.',

    'terms': {
      'apple-terms': 'Booksy works on an automatically renewing monthly subscription which depends on staff members number and will be charged to iTunes Account at confirmation of purchase. Purchasing subscription ends trial. Automatic reneval has the same monthly rate and will be done within 24-hours before end of current subscription period. You can cancell it any time by turning off the auto renewal setting for this app from your iTunes account. Cancellation must be done at least 24-hours before the payment is done, due to avoid being charged for the next month. For more info see our',
      'apple-terms-link': 'Privacy Policy & Subscription Terms of Service',
      'google-terms': 'Booksy Subscription',
      'google-terms-link': 'Terms & Conditions',
      'title': 'Booksy Subscription Terms & Conditions',
    },

    'subscription-status-message': {
      'warning': {
        'title': 'Your free trial will expire in {count} day | Your free trial will expire in {count} days | Your free trial will expire in {count} days',
        'text': `Currently you are using free Booksy version. See our offer. Help your business grow with 24/7 availability and calendar management through Booksy.`,
      },
      'expired': {
        'title': 'Your free trial has expired',
        'text': `You are no longer on free trial. Select the best plan for your business. Help your business grow with a 24/7 availability and calendar management through Booksy.`,
      },
      'overdue': {
        'title': 'Your subscription has not been renewed',
        'text': `Update your payment method and keep your business running smoothly.`,
      },
      'blocked': {
        'title': 'Your account has been blocked',
        'text': `Contact our customer success team to get more information`,
      },
      'disabled': {
        'title': 'Your account has been disabled due to lack of payment',
        'text': `Select your plan and resume your work`,
      },
    },

    'subscription-details': {
      'subscription-info': 'The tools you need to streamline your day-to-day so you have more time to do what you love.',
      'status': {
        'P': {
          'label': 'Active',
          'action': 'Change your plan',
        },
        'O': {
          'label': 'Payment failed',
          'action': 'Change your plan',
        },
        'L': {
          'label': 'Payment failed',
          'action': 'Change your plan',
        },
        'R': {
          'label': 'Payment failed',
          'action': 'Change your plan',
        },
      },
      'change-your-current-plan': 'Change your current plan',
      'change-your-plan': 'Change your plan',
      'change-subscription': 'Change your current subscription plan:',
      'fees': {
        'price': 'Price',
      },
      'text-messages': {
        'title': 'Text Messages',
        'description': 'Your Booksy subscription includes free Notification & Reminder texts. It might also include a limited amount of free Marketing texts. When you\'ve used up your free Marketing texts for the current monthly billing cycle you\'ll be charged per message. To see a summary of your current usage visit Billing Details.',
        'notifications-count': 'Number of free notification & reminder SMS',
        'notifications-count-unlimited': 'Unlimited',
        'sms-usage': 'SMS usage',
        'add-more-messages': 'Add more messages',
        'sms-settings': 'Text Messages Settings',
      },
      'blocked': {
        'title': 'Want more time to do what you love?',
        'description-1': 'Reactivate your subscription so that you can rely on Booksy for booking clients, marketing your business, managing the day-to-day, and building your community.',
        'description-2': 'We\'re more than appointments, We’re your partner, your sidekick, your employee of the month.',
        'pay-now': 'Pay now',
      },
      'cancel': {
        'read-more': 'Read more about',
        'how-to': 'how to cancel',
        'google-play': 'You can cancel your subsctiption anytime in Subscriptions section in Google Play. The fee will be charged automatically every month until you cancel your subscription.',
      },
      'manage-info': {
        'google-play': 'Your subscription is linked with your Google Play account.<br/>In order to manage your subscription please go to BooksyBiz application on Android device',
        'itunes-ipad': 'Your subscription is linked with your iTunes account.<br/>In order to manage your subscription please go to BooksyBiz application on iPad.',
        'itunes-iphone': 'Your subscription is linked with your iTunes account.<br/>In order to manage your subscription please go to BooksyBiz application on iPhone.',
      },
      'source-info': {
        'google-play': 'Your subscription is linked with your previous iTunes account. Please contact us to easily transfer your payment into your Android tablet.',
        'ios': 'Your subscription is linked with your previous Google Play account. Please contact us to easily transfer your payment into your iPad.',
        'ios-mobile': 'Your subscription is linked with your iPhone. Please contact us to easily transfer your payment into your iPad.',
      },
    },

    'error': {
      'itunes': {
        'clientInvalid': 'This action can’t be performed',
        'paymentCancelled': 'Payment request has been cancelled',
        'paymentInvalid': 'Payment is not valid',
        'paymentNotAllowed': 'Payment can’t be authorized',
        'storeProductNotAvailable': 'Subscription isn’t available in your region',
        'invalidOfferPrice': 'Selected price is no longer valid',
        'ineligibleForOffer': 'You’re not eligible for this subscription offer',
        'invalidOfferIdentifier': 'Selected subscription offer is not available',
      },
    },
  },

  'discounts': {
    'input': 'Discount code (optional)',
    'input-short': 'Discount code',
    'upcoming': 'Discount will apply in the upcoming billing cycle',
    'current': 'Discount applied to current billing cycle | Discounts applied to current billing cycle | Discounts applied to current billing cycle',
    'next': 'Discount will apply in the next billing cycle | Discounts will apply in the next billing cycle | Discounts will apply in the next billing cycle',
    'hint': {
      'title': 'How can I get a discount?',
      'description': 'You may receive a discount code from an event, from a marketing campaign, from someone at Booksy, or for attending a free webinar.',
    },
    'discount': 'Discounted rate with code {code}.',
    'discount-applied': 'Discount applied!',
    'discount-billing-cycle': 'Discount will apply in the upcoming billing cycle',
    'expiration': 'Expiration: in {days} days',
    'discount-month': 'Discounted rate for the first month with code {code}. | Discounted rate for {duration} months with code {code}. | Discounted rate for {duration} months with code {code}.',
    'discount-permanent': 'Lower price for the whole period of your subscription with the code {code}.',
    'discount-no-code': 'Special offer for the whole duration of subscription',
    'discount-single-month': 'Lower subscription price for a month with code {code}.',
    'regular-price': '{price} after month | {price} after first {duration} months | {price} after first {duration} months',
    'regular-price-net': '{price} ({priceSecondary} GROSS) after month | {price} ({priceSecondary} GROSS) after first {duration} months | {price} ({priceSecondary} GROSS) after first {duration} months',
    'regular-price-gross': '{price} ({priceSecondary} NET) after month | {price} ({priceSecondary} NET) after first {duration} months | {price} ({priceSecondary} NET) after first {duration} months',
    'permanent-price': 'Permanent discount for your subscription',
    'notification': 'Dicount code successfully added',
    'price': 'Price:',
  },

  'payment-status': {
    'transaction-successful': {
      'title': 'Payment Successful',
      'description': 'Your subscription has been activated.',
    },
    'transaction-failed': {
      'title': 'Transaction failed!',
    },
  },

  'go-online': {
    'top-bar': {
      'discount': {
        'title': 'As of July 1, you can only pay for Booksy by card. Get a {discount} discount now.',
      },

      'no-discount': {
        'title': 'As of July 1, you can only pay for Booksy by card. Save your card on file now.',
      },

      'discount-countdown': {
        'title': 'In {days} day, your account will be disabled. Get a {discount} discount now. | In {days} days, your account will be disabled. Get a {discount} discount now. | In {days} days, your account will be disabled. Get a {discount} discount now.',
      },

      'no-discount-countdown': {
        'title': 'In {days} day, your account will be disabled. Save your card on file now | In {days} days, your account will be disabled. Save your card on file now | In {days} days, your account will be disabled. Save your card on file now',
      },

      'learn-more': 'Learn more',
    },

    'pay-by-card-modal': {
      'no-discount': {
        'header1': 'Pay for Booksy by card!',
        'header2': 'Fast, convenient and secure',
        'text': 'With online subscription, payment for Booksy will be automatically charged to your payment card. Secure and always on time. Just save your card on file and you’ll no longer have to remember to pay your invoices.',
        'help-text': '',
      },
      'discount': {
        'header1': 'Get a discount on your subscription!',
        'header2': 'Pay for Booksy by card',
        'text': 'With online subscription, payment for Booksy will be automatically charged to your payment card. Secure and always on time. Just save your card on file and you’ll no longer have to remember to pay your invoices.',
        'percentage': '{percentage}',
        'period': 'for {count} month | for {count} months | for {count} months ',
        'help-text': '',
      },

      'countdown': {
        'text1': 'You have',
        'text2': '{count} day | {count} days | {count} days',
        'help-text': 'If you use Boost, commission fees will also be charged to your card.',
      },

      'no-discount-countdown': {
        'header1': 'Your account will soon be disabled',
        'header2': 'Switch to card payments!',
        'text': 'To continue using Booksy, save your card on file and next payments will be charged to your card automatically. Otherwise, your account will be disabled.',
      },

      'discount-countdown': {
        'header1': 'Your account will be disabled in&nbsp;{count}&nbsp;day | Your account will be disabled in&nbsp;{count}&nbsp;days | Your account will be disabled in&nbsp;{count}&nbsp;days',
        'header1-today': 'Your account will be disabled today',
        'header2': 'Switch to card payments!',
        'text': 'Your account will soon be disabled. To continue using Booksy, switch to online subscription payments and get a discount. Just save your card on file and next payments will be charged to your card automatically.',
      },
      'remind-me-later': 'Remind me later',
      'proceed': 'Continue',
    },
    'versum-migration': {
      'header': 'Welcome to Booksy!',
      'text': 'We’ve been waiting for you. Now there’s just one more step that you need to take to fully enjoy Booksy - add a payment card. Please do it within {count} day. You can check your subscription fees below. | We’ve been waiting for you. Now there’s just one more step that you need to take to fully enjoy Booksy - add a payment card. Please do it within {count} days. You can check your subscription fees below. | We’ve been waiting for you. Now there’s just one more step that you need to take to fully enjoy Booksy - add a payment card. Please do it within {count} days. You can check your subscription fees below. ',
      'info': 'We have sent you an email with a breakdown of all your subscription fees - please check your inbox. ',
      'add-card': 'Add card',
      'cancel-button': 'Remind me later',
      'days-counter': {
        'header': 'Add your payment card within ',
        'text': '{count} day | {count} days | {count} days',
      },
    },

    'welcome': {
      'header1': 'Pay for Booksy by card',
      'header2': 'Switch to online subscription',

      'text': `With online subscription, you no longer have to remember to make a payment for your subscription plan. Just save your card on file and payments will be charged automatically, just like in the case of popular VOD platforms`,

      'boost-info': 'As of July 1, 2023 card payment will be the only available payment method for Booksy subscription. You will no longer be able to use traditional bank transfers. If you have Boost enabled, commission fees will also be charged to your card.',

      'button': 'Continue',
    },

    'offer': {
      'header': 'Pay for Booksy by card',

      'text1': `If you switch to online subscription, your card will be charged automatically based on the invoice for your Booksy subscription. It will be activated once you make the first payment - in the next steps, we'll ask you to enter your card details, pay for your subscription and accept the Terms and Conditions.`,

      'text2': 'Once you switch to online subscription, your settlement period will be updated to begin from the day you stored your card details. Please pay the invoices issued before that using the previous payment method. In the case of an overpayment resulting from changing your billing period, we will issue a correcting invoice. You will receive it within 14 days of adding your card.',

      'price-label': {
        'many-staffers': 'Gross price for the account owner + {staffersCount} staff members:',
        'one-staffer': 'Gross price for the account owner + {staffersCount} staff member',
        'no-staffers': 'Gross price:',
      },

      'price': '{price} / mo',
      'button': 'Ok, got it',
      'button-offline': 'Switch to online subscription',
      'terms': 'Subscription Plan <strong>Terms & Conditions</strong>',
    },

    'price-help': {
      'header': 'What does the price include?',
      'text': `
        <p>
          It’s the monthly cost of your subscription including:
        </p>

        <ul>
          <li>Booksy Biz account,</li>
          {staffersOption}
          {smsOption}
        </ul>
        {boostInfo}
        <p>
          Once you switch to online subscription, you will still be receiving invoices but you won’t have to do anything - your card will be charged automatically.
        </p>`,
      'text-staffers-count': '<li>access for {count} staff member,</li> | <li>access for {count} staff members,</li> | <li>access for {count} staff members,</li>',
      'text-sms-count': '<li>{count} marketing text message for free.</li> | <li>{count} marketing text messages for free.</li> | <li>{count} marketing text messages for free.</li>',
      'boost-info': 'Boost fees will be calculated on an ongoing basis for acquired clients. There is no flat rate fee for using Boost.',
      'button': 'Ok, got it',
    },

    'agreements': {
      'title': 'One last step',

      'option1': 'I accept the Terms and Conditions and confirm that I have read the Privacy Policy',

      'option2': 'I confirm that only the Terms and Conditions define the mutual obligations between me and Booksy. Previous contracts in this regard are terminated.',

      'option3': 'I confirm the obligations between me and Booksy regarding Booksy Boost are solely defined by the Terms and Conditions. Any previous agreements in this regard are therefore terminated. However, the commission fee and the duration of my contract shall not change.',

      'button': 'Accept and switch to online subscription',
      'modal-title': 'Terms and Conditions and Privacy Policy',
      'modal-content-1': `
        I want to use the Booksy service owned by Booksy International sp. z o.o. with its registered office in Warsaw, KRS number 0000515914 ("Booksy"), for the purpose of entering into and executing a contract for the use of the Booksy service, enabling contact between me and the Customer for the purpose of advertising, promoting, offering and booking Services, as well as managing the operations of my business.
      `,

      'modal-content-2': `
        Thus, I accept the Terms and Conditions of service set forth in {termsUrl} ("Terms and Conditions") and enter into a contract with Booksy for the processing of personal data, under the provisions set forth in these Terms and Conditions. I also confirm that I have read {privacyUrl}, which defines the rules of personal data processing by Booksy.
      `,
      'terms-url-label': 'Terms and Conditions',
      'privacy-url-label': 'Privacy Policy',
    },

    'reminder': {
      'header': 'Check out online subscription!',
      'text': 'Don’t waste time keeping track of invoice due dates. Save your card on file and automate your Booksy subscription payments!',
      'button': 'Switch to online subscription',
    },

    'exit': {
      'title': 'Hey, don’t leave!',
      'subtitle': 'We’re almost there',
      'text': `Just a few more steps and you will switch to online subscription. Enter your card details so that bank transfers can become a thing of the past!`,
      'button': 'Enter card details',
    },

    'boost': {
      'header': 'Pay for Booksy by card',
      'text': 'To activate online subscription, enter the details of your card, use it to pay for your subscription and accept the Terms and Conditions.',
    },

    'cards': {
      'subscription': {
        'header1': 'Subscription',
        'text': 'If there’s an overpayment resulting from changing your billing period, you’ll receive a correcting invoice within 14 days.',
        'option1': 'Payments charged once a month',
        'option2': 'Your billing period will start on the day you add your card',
      },
      'boost': {
        'header1': 'Boost',
        'text': 'You’ll have 7 days after the end of your billing period to claim your clients.',
        'option1': 'Commission fees will be charged daily',
        'option2': 'Your billing period will start on the day you add your card',
      },
    },
  },

  'staffer-blocked-info': {
    title: 'Subscription Payment Overdue',
    subtitle: 'Contact the account administrator',
    description: 'Looks like we haven\'t received the payment for Booksy subscription. Please get in touch with the account administrator. You\'ll be able to access Booksy as soon as we receive the payment.',
  },
}
